import React from "react";
import "./WelcomeScreen.css";

export default function Welcome() {
  return (
    <div className="background-relative">
      <div className="background-guy"></div>
    </div>
  );
}
